import { render } from "./tax-and-shipping.vue?vue&type=template&id=bbe43606&scoped=true"
import script from "./tax-and-shipping.vue?vue&type=script&lang=js"
export * from "./tax-and-shipping.vue?vue&type=script&lang=js"

import "./tax-and-shipping.vue?vue&type=style&index=0&id=bbe43606&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbe43606"]])

export default __exports__